import React, { useState } from "react";
import UseGetDashBoardWithParams from "../../../../../Components/Hooks/useDashboardDataParams";
import capitalizeFirstLetter from "../../../../../Components/Utils/Funcs";

const Buyer = () => {
  const currentMonth = new Date().getMonth() + 1;
  const [params, setParams] = useState({ month: currentMonth });
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const { data, loading } = UseGetDashBoardWithParams(`/new-dashboard/procurement/ypr-actioned`, params);

  const handleMonthChange = (e) => {
    const newMonth = e.target.value;
    setParams({ month: newMonth });
    setSelectedMonth(newMonth);
  };

  const months = [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
  ];

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Buyer YPR Performance</h3>
        </div>

        <select
          value={selectedMonth}
          onChange={handleMonthChange}
          className="bg-gray-50 border border-gray-200 rounded-lg px-2.5 py-1 text-xs font-medium text-gray-700 outline-none"
        >
          {months.map((m) => (
            <option key={m.value} value={m.value}>
              {m.name}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Buyer Representative</th>
                <th className="py-2 px-1 text-center">Total</th>
                <th className="py-2 px-1 text-center">Quotes</th>
                <th className="py-2 px-1 text-center">Rem.</th>
                <th className="py-2 px-1 text-center">Ord. Rec.</th>
                <th className="py-2 px-1 text-center">Ord. Placed</th>
                <th className="py-2 px-2 text-right">Loc/Int</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                    <td className="py-2.5 px-2 font-medium text-gray-800 truncate max-w-[110px]">
                      {capitalizeFirstLetter(item?.name || "N/A")}
                    </td>
                    <td className="py-2.5 px-1 text-center font-semibold text-gray-800">{item?.total || 0}</td>
                    <td className="py-2.5 px-1 text-center text-purple-600 font-semibold">{item?.submited || 0}</td>
                    <td className="py-2.5 px-1 text-center text-amber-600 font-semibold">{item?.remaining || 0}</td>
                    <td className="py-2.5 px-1 text-center text-blue-600 font-semibold">{item?.received || 0}</td>
                    <td className="py-2.5 px-1 text-center text-emerald-600 font-semibold">{item?.placed || 0}</td>
                    <td className="py-2.5 px-2 text-right font-medium text-gray-500">{item?.localInternational || 0}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="py-6 text-center text-gray-400">
                    No buyer data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Buyer;
